import React from 'react'
import './Service.css'
import Icons from '../home-pages/Icons'
import OurService from './OurService'
import Approach from '../home-pages/Approach'
import CaseStudy from '../home-pages/CaseStudy'
import Form from '../home-pages/Form'
import Footer from '../home-pages/Footer'
import '@fontsource/manrope'; // Default weight is 400




export default function Service() {
  return (
    <>
    <div>
      <div className="service-section">
              
      
              <div className="service-content">
         
          <div className="service-text">
            <h1 className="service-content-h">Our Services</h1>
            <p>
            We create innovative custom software solutions that keep up with the latest developments in the technology industry.


            </p>
          </div>
      
          {/* Button beside the text */}
          <button className="cta-button-service"> LET'S DISCUSS YOUR PROJECT<span className="arrow-service">🡥</span></button>
        </div>
      </div>
     
    </div>
    <Icons/>
    <OurService/>
   
    <Approach/>
    <CaseStudy/>
    <Form/>
    <Footer/>
    
    </>
  )
}
